import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export function Wrapper(props) {
  const className = `design-view__groupA ${props.className}`;

  return <div className={className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * child components
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

Wrapper.defaultProps = {
  className: '',
  children: undefined,
};
